// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".align-middle-vertical[data-v-c04c7982] {\n  line-height: 35px;\n}\ntd[data-v-c04c7982], tr[data-v-c04c7982] {\n  vertical-align: middle;\n}\n.chip-width[data-v-c04c7982] {\n  width: 92px;\n}", ""]);
// Exports
module.exports = exports;
